import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getPermissions, getCompany, getSubcompany } from 'auth/selectors';
import * as Depreciations from 'depreciations/components';

class DepreciationsRowContainer extends Component {
  render = () => (
    <Depreciations.Row
      handleToggle={this.props.handleToggle} /////////////
      company={this.props.company}
      subcompany={this.props.subcompany}
      depreciation={this.props.depreciation}
      permissions={this.props.permissions}
    />
  );
}

const mapStateToProps = (state) => ({
  permissions: getPermissions(state),
  company: getCompany(state),
  subcompany: getSubcompany(state),
});

const mapDispatchToProps = {}; //////////

export default connect(mapStateToProps, mapDispatchToProps)(DepreciationsRowContainer);



// WEBPACK FOOTER //
// src/modules/secured/modules/depreciations/containers/DepreciationRowContainer.js